import { Link, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/terms')({
  component: TermsPage,
});

const SUPPORT_EMAIL = 'support@pirouettehq.com';

function TermsPage() {
  return (
    <main
      id="main"
      className="min-h-dvh bg-[var(--color-surface-sunken)] px-6 py-10 text-[var(--color-ink)] sm:px-10 lg:px-16"
      data-testid="terms-page"
    >
      <div className="mx-auto flex max-w-4xl flex-col gap-8">
        <nav aria-label="Public navigation" className="flex items-center justify-between gap-6">
          <Link
            to="/"
            className="font-[var(--font-display)] tracking-[var(--tracking-wide)] text-[var(--text-lg)] uppercase"
          >
            Pirouette
          </Link>
          <div className="flex items-center gap-5 text-[var(--text-sm)]">
            <Link to="/privacy" className="text-[var(--color-ink-muted)] hover:underline">
              Privacy
            </Link>
            <Link to="/contact" className="text-[var(--color-ink-muted)] hover:underline">
              Contact
            </Link>
          </div>
        </nav>

        <header>
          <p className="font-[var(--font-display)] tracking-[var(--tracking-wide)] text-[var(--color-accent)] text-[var(--text-base)] uppercase">
            Terms
          </p>
          <h1 className="mt-4 leading-[var(--leading-tight)] font-[var(--font-display)] tracking-[var(--tracking-tight)] text-[var(--text-display)]">
            Pirouette terms and SMS conditions
          </h1>
          <p className="mt-4 text-[var(--color-ink-muted)]">Effective June 8, 2026</p>
        </header>

        <section className="space-y-6 rounded-[var(--radius-lg)] border border-[var(--color-border)] bg-[var(--color-surface)] p-6 leading-[var(--leading-relaxed)] text-[var(--color-ink-muted)]">
          <div>
            <h2 className="font-semibold text-[var(--color-ink)] text-[var(--text-xl)]">
              Service use
            </h2>
            <p className="mt-2">
              Pirouette provides dance-studio management tools for studios, staff, families, and
              authorized users. Users are responsible for keeping account credentials secure,
              entering accurate information, and using the service only for lawful studio
              operations.
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-[var(--color-ink)] text-[var(--text-xl)]">
              Studio responsibilities
            </h2>
            <p className="mt-2">
              Studios are responsible for their roster, class, billing, message, consent, and
              recital data. Studios must have the rights and permissions required to enter family,
              dancer, payment, media, and communication information into Pirouette.
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-[var(--color-ink)] text-[var(--text-xl)]">
              Payments
            </h2>
            <p className="mt-2">
              Payment features are processed through connected payment providers. Studio-specific
              tuition, fees, recital charges, refunds, cancellations, and payment policies are set
              by the studio unless Pirouette states otherwise in a separate written agreement.
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-[var(--color-ink)] text-[var(--text-xl)]">
              Pirouette SMS alerts
            </h2>
            <p className="mt-2">
              Pirouette SMS alerts are optional transactional account notifications for dance-studio
              families. They may include class schedule changes and tuition payment issue alerts.
              Message frequency varies. Message and data rates may apply.
            </p>
            <p className="mt-2">
              Reply <strong>STOP</strong> to unsubscribe. Reply <strong>HELP</strong> for help.
              Support is available at{' '}
              <a href={`mailto:${SUPPORT_EMAIL}`} className="text-[var(--color-accent)]">
                {SUPPORT_EMAIL}
              </a>
              . Carriers are not liable for delayed or undelivered messages.
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-[var(--color-ink)] text-[var(--text-xl)]">
              Acceptable use
            </h2>
            <p className="mt-2">
              Users may not use Pirouette to send unlawful, abusive, misleading, or unauthorized
              communications. SMS may not be used for marketing unless a separately approved
              campaign, consent basis, and product gate explicitly allow that use.
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-[var(--color-ink)] text-[var(--text-xl)]">Contact</h2>
            <p className="mt-2">
              Questions about these terms can be sent to{' '}
              <a href={`mailto:${SUPPORT_EMAIL}`} className="text-[var(--color-accent)]">
                {SUPPORT_EMAIL}
              </a>
              . See the{' '}
              <Link to="/privacy" className="text-[var(--color-accent)]">
                Privacy Policy
              </Link>{' '}
              for information about data use and SMS consent data.
            </p>
          </div>
        </section>
      </div>
    </main>
  );
}
